import '../../styles/pdf.css'
import React, {forwardRef, ReactNode, useEffect, useRef, } from "react";
import {useAppSelector} from "../../hooks";
import {convertToRoman, formatInternationalPhoneNumber, formatPrice, getNoun, getQuarter} from "../helpers";
import {useSearchParams} from "react-router-dom";
import {defaultIcon} from "../map/mapData";
import Main from "../main/main";

interface Props {
    ref: ReactNode,
    data: any,
    status: string,
    hasDownloadRoute: boolean
}

const Pdf = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const {data, status, hasDownloadRoute } = props;

    const {dataStatic} = useAppSelector(state => state.dataStatic);
    // const [searchParams, ] = useSearchParams();

    const cardContactsRef = useRef<HTMLDivElement>(null)
    const cardContactsContent = useRef<HTMLDivElement>(null);
    const refAgent = useRef<HTMLDivElement>(null);
    const cardTitleContactsRef = useRef<HTMLDivElement>(null)
    const refContactsDecorator = useRef<HTMLDivElement>(null)

    // function countPagePdf(){
    //     const pages = (document.querySelector('.pdf-container') as HTMLElement);
    //     if(pages){
    //         for (let i=0; i < pages.children.length; i++){
    //             const currentPageNodes = pages.children[i].children;
    //             const num = currentPageNodes[currentPageNodes.length - 1];
    //             if(num.className === 'num'){
    //                 num.innerHTML = (1 + i).toString();
    //             }
    //         }
    //     }
    // }
    //
    // useEffect(() => {
    //     countPagePdf();
    //     if(cardTitleContactsRef.current && cardContactsContent.current && refContactsDecorator.current){
    //         const widthTitle = cardTitleContactsRef.current.clientWidth;
    //         const widthContacts = cardTitleContactsRef.current.clientWidth;
    //         cardContactsContent.current.style.cssText = `
    //             right: -${(widthContacts - widthTitle + 180)}px;
    //         `
    //         cardTitleContactsRef.current.style.cssText = `
    //             left: ${-widthTitle + 40}px;
    //         `
    //         refContactsDecorator.current.style.cssText = `
    //             height: ${cardContactsContent.current.clientHeight}px;
    //         `
    //     }
    // }, [ref]);
    if (!props.data || !props.data.data) return null; // <-- вернуть null, а не undefined
    return (
        <div ref={ref} className={status ? 'pdf-container-loading' : 'pdf-container'}
            style={{
                zIndex: '15',
                position: 'fixed',
            }}
        >
            <Main data={data.data} hasDownloadRoute={hasDownloadRoute}/>
        </div>
    )
});

export default Pdf;